<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useConfirmDeleteStore } from '@/stores/confirmDelete'

const confirmDeleteStore = useConfirmDeleteStore()
const { isOpen, loading, options } = storeToRefs(confirmDeleteStore)
</script>

<template>
  <v-dialog
    :model-value="isOpen"
    max-width="600"
    persistent
    @update:model-value="(value) => !value && confirmDeleteStore.onCancel()"
  >
    <v-card class="pa-3">
      <v-card-title>{{ options.title }}</v-card-title>
      <v-card-text class="pt-3 pl-4">
        <div>{{ options.message }}</div>
        <div v-if="options.name" class="font-weight-bold mt-1">{{ options.name }}</div>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-spacer />
        <v-btn
          variant="text"
          color="primary"
          class="text-none"
          :disabled="loading"
          @click="confirmDeleteStore.onCancel()"
        >
          {{ options.cancelText }}
        </v-btn>
        <v-btn
          variant="text"
          :color="options.confirmColor"
          class="text-none"
          :loading="loading"
          @click="confirmDeleteStore.onConfirm()"
        >
          {{ options.confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
